import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 40, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, lineClassName = "", as: Tag = "span" }) {
  return (
    <>
      {lines.map((line, i) => (
        <span className="mask-line" key={i}>
          <motion.span
            className={lineClassName}
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.15, delay: 0.25 + i * 0.16, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <p className={`text-[11px] font-label uppercase tracking-[0.35em] text-imperium-bronze ${className}`} data-testid="section-eyebrow">
      {children}
    </p>
  );
}

export function ChapterNo({ children }) {
  return (
    <span className="font-serif italic text-imperium-champagne text-2xl leading-none" aria-hidden="true">
      {children}
    </span>
  );
}
